export enum CreateNewInvitationStep {
  InvitationForm = 'InvitationForm',
  InvitationCreated = 'InvitationCreated',
}
